// Upload tab constants
export const UPLOAD_TAB_VAULTS = 'vaults' as const;
export const UPLOAD_TAB_EXCEL = 'excel' as const;

// File type restrictions
// "" (empty string) allows files with no extension (like Leumi vault files)
export const VAULT_FILE_TYPES = [
  '.txt',
  '.xml',
  '.csv',
  '.xlsx',
  '.xls',
  '.zip',
  '',
];
export const EXCEL_FILE_TYPES = ['.xlsx', '.xls', '.csv'];

// Max file size
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Error messages
export const ERROR_MESSAGES = {
  // Detection failures
  DETECTION_FAILED: 'Failed to detect vault types',

  // Upload failures
  UPLOAD_FAILED: 'Failed to upload files',

  // Parse failures
  PARSE_FAILED: 'Failed to parse vault files',
  PARSE_ALL_FAILED: 'All files failed to parse. Please check file formats.',

  // Missing data
  MISSING_FILE_ID: '⚠️ Missing file_id - cannot proceed',
  MISSING_SESSION_ID: '⚠️ Missing session_id - cannot proceed',

  // File size
  FILE_TOO_LARGE: (filename: string) =>
    `File '${filename}' exceeds maximum size of ${MAX_FILE_SIZE_MB}MB`,

  // Validation
  NO_VAULT_FILES: 'Please upload at least one vault file',
  NO_EXCEL_FILES: 'Please upload at least one Excel file',
  UNMAPPED_BANKS: 'Please ensure all files are mapped to a bank',

  // Save failures
  SAVE_FAILED: 'Failed to save file. Please try again.',
  SESSION_CREATION_FAILED: 'Failed to create wizard session. Please try again.',
};

// Success messages
export const SUCCESS_MESSAGES = {
  UPLOAD_VAULT_SUCCESS: (count: number) =>
    `Successfully uploaded ${count} vault file(s)`,
  UPLOAD_EXCEL_SUCCESS: 'Successfully uploaded Excel file',
  PARTIAL_SUCCESS: (successCount: number, failedCount: number) =>
    `Uploaded ${successCount} file(s). ${failedCount} failed.`,
};
